import React from "react";
import icon from "../../assets/trade.png";

export default function SwapIcon({ size }) {
  return <img src={icon} width={size} />;
}
